import SiteJoursFeriesController from './site.jours.feries.controller';

export default {
    template: require('./site.jours.feries.html'),
    controller: SiteJoursFeriesController
};
